import React from 'react';
export function Footer() {
  return <footer className="bg-[#232b21] text-[#a7b09c] py-14 border-t border-[#3a4434] pt-[30px] pb-[30px]" data-id="element-79">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-80">
        <div className="text-white font-bold text-xl mb-6 flex items-center justify-center gap-2" data-id="element-81">
          🛡️ KIT OPERATIVO PARA PSICÓLOGOS
        </div>

        <p className="text-sm max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-82">
          Este producto es una herramienta de organización y documentación para
          psicólogos en ejercicio independiente. No constituye asesoramiento
          clínico, legal ni impositivo, ni reemplaza la supervisión profesional
          ni la consulta con un especialista matriculado.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm mb-8" data-id="element-83">
          <a href="#" className="hover:text-white transition-colors" data-id="element-84">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-85">
            Política de Privacidad
          </a>
          <a href="mailto:soporte@mega-pack-hys.com" className="hover:text-white transition-colors" data-id="element-86">
            Contacto
          </a>
        </div>

        <div className="text-xs text-[#6f7a64]" data-id="element-87">
          <p data-id="element-88">
            © 2026 Kit Operativo para Psicólogos — Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}